<template>
  <div>
    <v-menu
      v-model="menu"
      open-on-hover
      bottom
      left
      offset-y
      :close-on-content-click="false"
      v-if="storeId"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-chip
          v-bind="attrs"
          v-on="on"
          :color="loading ? 'grey' : connections > 0 ? 'success' : 'error'"
          label
          small
          :loading="!loading"
        >
          <v-progress-circular
            v-if="loading"
            size="16"
            width="2"
            indeterminate
            color="white"
            class="mr-2"
          ></v-progress-circular>
          <v-icon small left v-else>
            mdi-monitor{{ connections > 0 ? "" : "-off" }}
          </v-icon>
          {{ connections > 0 ? "Conectado" : "Desconectado" }}
        </v-chip>
      </template>
      <v-card style="width: 270px" rounded="lg">
        <div v-if="connections == 0">
          <v-card-title>
            <v-icon small left>mdi-monitor-off</v-icon>
            <h5 class="mb-0">Nenhum terminal conectado</h5>
          </v-card-title>
          <v-card-text>
            <h6 class="mb-2">O que pode ser feito no terminal?</h6>
            <ul>
              <li>Verificar se está ligado</li>
              <li>Verificar se tem conexão com a internet</li>
              <li>Verificar se está atualizado</li>
              <li>Verificar se o cliente está instalado e rodando</li>
            </ul>
          </v-card-text>
        </div>
        <div v-else>
          <v-card-title>
            <v-icon small left>mdi-monitor</v-icon>
            <h5 class="mb-0">Terminal conectado</h5>
          </v-card-title>
          <v-card-text>
            <v-progress-linear
              v-if="loadingDevicesInfo"
              indeterminate
              width="20"
              color="primary"
              class="mt-2 mb-2"
            ></v-progress-linear>
            <template v-else-if="devicesInfo">
              <div>
                <h6 class="mb-2">Informações do terminal</h6>
                <p class="text-truncate mb-0">
                  <b>Modelo:</b> {{ devicesInfo.model }}
                </p>
                <p class="text-truncate mb-0">
                  <b>Firmware:</b> {{ devicesInfo.firmware }}
                </p>
                <p class="text-truncate mb-0">
                  <b>Serial:</b> {{ devicesInfo.serial }}
                </p>
                <p class="text-truncate">
                  <b>Versão:</b> {{ devicesInfo.version }}
                </p>
              </div>
            </template>

            <h6 class="mb-2">Câmera do terminal</h6>
            <div style="position: relative">
              <v-img
                :src="cameraPicture"
                width="100%"
                height="150px"
                :aspect-ratio="16 / 9"
                contain
              >
                <template v-slot:placeholder>
                  <v-skeleton-loader
                    type="image"
                    width="100%"
                    height="100%"
                  ></v-skeleton-loader
                  >] here
                </template>
              </v-img>
              <div
                v-if="errorCameraPicture"
                class="d-flex justify-center align-center"
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
              >
                <v-icon color="error">mdi-alert-circle</v-icon>
                <span>Erro ao carregar a câmera</span>
              </div>
            </div>
          </v-card-text>
        </div>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import STORE from "@/services/store";
export default {
  name: "DesktopClientIndicator",
  data() {
    return {
      timer: null,
      connections: 0,
      menu: false,
      devicesInfo: null,
      loading: false,
      loadingDevicesInfo: false,
      loadingCameraPicture: false,
      cameraPicture: null,
      storeId: null,
      errorCameraPicture: false,
    };
  },
  methods: {
    async getDesktopClient(loading = true) {
      try {
        if (this.timer) clearTimeout(this.timer);
        if (this.loading) return;
        if (!this.storeId) return;

        this.loading = loading;
        const response = await STORE.desktopClient.getStatus(this.storeId);
        this.connections = response.connections;

        if (this.menu) {
          this.getDevicesInfo();
          this.getCameraPicture();
        }

        this.timer = setTimeout(() => {
          this.getDesktopClient(false);
        }, 5000);
      } catch (error) {
        this.loading = false;
        this.connections = 0;
        this.devicesInfo = null;
        this.cameraPicture = null;
      } finally {
        this.loading = false;
      }
    },
    async getDevicesInfo() {
      try {
        if (this.loadingDevicesInfo) return;
        if (this.connections === 0) return;
        if (this.devicesInfo) return;
        this.loadingDevicesInfo = !this.devicesInfo;
        const response = await STORE.desktopClient.getInfo(this.storeId);
        this.devicesInfo = response.devicesInfo;
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingDevicesInfo = false;
      }
    },
    async getCameraPicture() {
      try {
        if (this.loadingCameraPicture) return;
        if (this.connections === 0) return;
        this.loadingCameraPicture = true;
        this.errorCameraPicture = false;
        const response = await STORE.desktopClient.getCameraPicture(
          this.storeId
        );
        this.cameraPicture = response.picture;
      } catch (error) {
        console.log(error);
        this.errorCameraPicture = true;
      } finally {
        this.loadingCameraPicture = false;
      }
    },
    loadStoreId(newVal) {
      const currentStoreId = this.storeId;
      const newStoreId = newVal?.id || this.$route?.params?.id;
      this.storeId = newStoreId;
      if (currentStoreId !== this.storeId) {
        this.devicesInfo = null;
        this.cameraPicture = null;
        this.getDesktopClient();
      }
    },
  },
  watch: {
    menu(newVal) {
      if (!newVal) return;
      this.getDevicesInfo();
      this.getCameraPicture();
    },
    "$route.params": {
      handler(newVal) {
        console.log(newVal);
        this.loadStoreId(newVal);
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["store"]),
  },
  mounted() {
    this.loadStoreId();
    this.getDesktopClient();
  },
  beforeDestroy() {
    if (this.timer) clearTimeout(this.timer);
  },
};
</script>
